import { useLocation } from 'react-router-dom';

/**
 * Used to abstract the use correct search key
 *
 * @returns Search query from the URL
 */
export const useSearchQuery = () => {
    const { search } = useLocation();
    return new URLSearchParams(search).get('q');
};
